import { reducer } from './reducers';
import { configureStore } from '@reduxjs/toolkit';
import { rtkErrorLogger } from './rtk-logger';
import { ControllerMiddlewares } from '@src/core/controllers/store';
import { OrderFeatureMiddlewares } from '@src/features/order/store';
import { IntegrationFeatureMiddlewares } from '@src/features/integration/store';
import { FleetFeatureMiddlewares } from '@src/features/fleet/store';
import { DroneFeatureMiddlewares } from '@src/features/drone/store';
import { AuthFeatureMiddlewares } from '@src/features/auth/store';
import { ProfileCoreMiddlewares } from '@src/core/features/profile/store';
import { SettingsCoreMiddlewares } from '@src/core/features/settings/store';
import { ZonesCoreMiddlewares } from '@src/core/features/zones/store';
import { DroneCoreMiddlewares } from '@src/core/features/drone/store';
import { AnalyticsFeatureMiddlewares } from '@src/features/analytics/store';

const middlewares = [
  ...AuthFeatureMiddlewares,
  ...ControllerMiddlewares,
  ...OrderFeatureMiddlewares,
  ...DroneFeatureMiddlewares,
  ...ProfileCoreMiddlewares,
  ...SettingsCoreMiddlewares,
  ...FleetFeatureMiddlewares,
  ...IntegrationFeatureMiddlewares,
  ...ZonesCoreMiddlewares,
  ...DroneCoreMiddlewares,
  ...AnalyticsFeatureMiddlewares,
  rtkErrorLogger
];

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(middlewares),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export { store };